import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_USERS_MERCHANT_APPLICATION,
  GET_USER_CAN_MAKE_APPLICATION,
  GET_USER_CAN_APPROVE_AGREEMENT,
  ADD_MERCHANT_APPLICATION,
  APPROVE_MERCHANT_AGREEMENT,
  UPLOAD_MERCHANT_FILE,
  DELETE_MERCHANT_FILE,
  UPLOAD_MERCHANT_FILE_LIST,
  GET_MERCHANT_APPLICATION_DOCUMENT,
  GET_MERCHANT_APPLICATION_DOCUMENT_FILE
} from "./actionTypes"

import {
  addMerchantApplicationSuccess,
  getUsersMerchantApplicationSuccess,
  getUserCanMakeApplicationSuccess,  
  getUserCanApproveAgreementSuccess,  
  approveMerchantAgreementSuccess,
  uploadMerchantFileSuccess,
  merchantApplicationApiError,
  deleteMerchantFileSuccess,
  uploadMerchantFileListSuccess,
  getApplicationDocumentByGuidSuccess,
  getMerchantFileViewSuccess,
} from "./actions"

import {
addMerchantApplication,
getUsersMerchantApplicationList,
getUserCanMakeApplication,
getUserCanApproveAgreement,
approveMerchantAgreement,
uploadMerchantFile,
deleteMerchantFile,
uploadMerchantFileList,
getMerchantApplicationDocumentList,
getMerchantFileBySubMerchantId,
} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetUsersMerchantApplicationList({ payload: record }) {
  try {
    const response = yield call(getUsersMerchantApplicationList, record)
    yield put(getUsersMerchantApplicationSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}
function* onGetUserCanMakeApplication({ payload: record }) {
  try {
    const response = yield call(getUserCanMakeApplication, record)
    yield put(getUserCanMakeApplicationSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}
function* onGetUserCanApproveAgreement({ payload: record }) {
  try {
    const response = yield call(getUserCanApproveAgreement, record)
    yield put(getUserCanApproveAgreementSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* onAddMerchantApplication({ payload: record }) {
  try {
    const response = yield call(addMerchantApplication, record)
    yield put(addMerchantApplicationSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}


function* onApproveMerchantAgreement({ payload: record }) {
  try {
    const response = yield call(approveMerchantAgreement, record)
    yield put(approveMerchantAgreementSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}
function* onUploadMerchantFile({ payload: file }) {
  try {
    const response = yield call(uploadMerchantFile, file)
    yield put(uploadMerchantFileSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* onUploadMerchantFileList({ payload: fileList }) {
  try {
    const response = yield call(uploadMerchantFileList, fileList)
    yield put(uploadMerchantFileListSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* onDeleteMerchantFile({ payload: file }) {
  try {
    const response = yield call(deleteMerchantFile, file)
    yield put(deleteMerchantFileSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* getMerchantApplicationDocument({ payload: guid }) {
  try {
    const response = yield call(getMerchantApplicationDocumentList, guid)
    yield put(getApplicationDocumentByGuidSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* getMerchantFileView({ payload: subMerchantId }) {
  try {
    const response = yield call(getMerchantFileBySubMerchantId, subMerchantId)
    yield put(getMerchantFileViewSuccess(response))
  } catch (error) {
    yield put(merchantApplicationApiError(error))
  }
}

function* merchantApplicationSaga() {

    yield takeEvery(GET_USERS_MERCHANT_APPLICATION,onGetUsersMerchantApplicationList)
    yield takeEvery(GET_USER_CAN_MAKE_APPLICATION,onGetUserCanMakeApplication)
    yield takeEvery(GET_USER_CAN_APPROVE_AGREEMENT,onGetUserCanApproveAgreement)
    yield takeEvery(ADD_MERCHANT_APPLICATION,onAddMerchantApplication)
    yield takeEvery(APPROVE_MERCHANT_AGREEMENT,onApproveMerchantAgreement)
    yield takeEvery(UPLOAD_MERCHANT_FILE,onUploadMerchantFile)
    yield takeEvery(UPLOAD_MERCHANT_FILE_LIST,onUploadMerchantFileList)
    yield takeEvery(DELETE_MERCHANT_FILE,onDeleteMerchantFile)
    yield takeEvery(GET_MERCHANT_APPLICATION_DOCUMENT,getMerchantApplicationDocument)
    yield takeEvery(GET_MERCHANT_APPLICATION_DOCUMENT_FILE,getMerchantFileView)
}

export default merchantApplicationSaga
